// hooks/useSingleTheme.js - VERSIONE AXIOS
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useSingleTheme = (themeId) => {
    const [theme, setTheme] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        const fetchTheme = async () => {
            try {
                setLoading(true);
                setError(null);

                console.log(`🔍 Cercando tema con ID: "${themeId}"`);
                
                const url = `/api/themes/${themeId}`;
                
                const response = await axios.get(url, {
                    cancelToken: source.token
                });
                
                console.log('📦 Response data:', response.data);
                
                if (response.data.success && response.data.data) {
                    setTheme(response.data.data);
                } else {
                    setTheme(null);
                    if (response.data.message) {
                        console.warn('⚠️ No theme data:', response.data.message);
                    }
                }
                
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error('❌ Error fetching theme:', err.message);
                    setError(err.message);
                    setTheme(null);
                }
            } finally {
                setLoading(false);
            }
        };

        if (themeId) {
            fetchTheme();
        } else {
            setLoading(false);
        }
        
        return () => source.cancel('Component unmounted');
    }, [themeId]);

    return { theme, loading, error };
};